import React from "react";
import { CNXT_DOMAIN, CNXT_JWT } from "../../constants/storageKeys";
import { UseGlobalState } from "../../state/gsh/gsh";

import { debugLog } from "../../util/debug";

export default function TabRedirect() {
    const [destination, setDestination] = React.useState('');
    const [state, setState] = UseGlobalState()

    React.useEffect(() => {
        debugLog('TabRedirect useEffect')
        if (!!!destination) {
            const domain = window.localStorage.getItem(CNXT_DOMAIN)
            const jwt = window.localStorage.getItem(CNXT_JWT)
            const pattern = process.env.REACT_APP_TABS_TEMPLATE

            // eslint-disable-next-line no-template-curly-in-string
            let dest = pattern.replace('${domain}', `${domain}`)

            // eslint-disable-next-line no-template-curly-in-string
            dest = dest.replace('${jwt}', `${jwt}`)

            // eslint-disable-next-line no-template-curly-in-string
            dest = dest.replace('${state.tabQueryString}', `${state.tabQueryString}`)
            setDestination(dest)

           window.location.replace(dest)
        }
    },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [destination]);

    return (
        <div className="App">
        </div>
    )
}